
import React, { useContext, useEffect, useState, useRef } from "react";
import { Modal, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { InsertApplicationsHousing } from "../../../../infrastructure/repositories/ApplicationsHousingRepository";
import { setLocalItem } from "../../../../infrastructure/storage/LocalStorage";

const { Title, Paragraph } = Typography;


export default function ApplicationsModal({
  texts,
  open,
  idBusquedaVisitante,
  idUsuario,
  onClose,
  to,
  ctaLabel = texts?.LB0986 || "Ver recomendaciones",
  title = texts?.LB0987 || "¡Felicidades!",
  description = texts?.LB0988 || "¡Ahora estás más cerca de encontrar tu vivienda ideal!",
}) {
  const navigate = useNavigate();

  const [applicationHousing, setApplicationHousing] = useState(null);
  const [loading, setLoading] = useState(false);
  const calledRef = useRef(false); 

  useEffect(() => {
    if (!open) return;
    if (!idBusquedaVisitante || !idUsuario) return;
    if (calledRef.current) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const payload = { idBusquedaVisitante, idUsuario };
        const res = await InsertApplicationsHousing(payload);
        const data = res?.data ?? res; 

        if (cancelled) return;

        setApplicationHousing(data);
        setLocalItem("ApplicationHousing", data);

        calledRef.current = true;
      } catch (error) {
        if (!cancelled) console.error("InsertApplicationsHousing failed:", error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [open, idBusquedaVisitante, idUsuario]);

  const handleContinue = () => {
    localStorage.removeItem("idBusquedaVisitante");
    if (typeof onClose === "function") onClose();
    if (to) navigate(to);
  };

  return (
    <Modal
      open={open}
      footer={null}
      centered
      width={520}
      maskClosable={false}
    >
      <Title level={3} style={{ textAlign: "center", marginBottom: 8 }}>
        {title}
      </Title>

      <Paragraph style={{ textAlign: "center", marginBottom: 24 }}>
        {description}
      </Paragraph>

      <Button style={{ backgroundColor: "var(--main-viva-color)", color: "#ffffff",borderRadius: "20px", fontWeight: "600", border: "none" }} size="large" block onClick={handleContinue} disabled={loading}>
        {loading ? "Guardando..." : ctaLabel}
      </Button>
    </Modal>
  );
}
